export default {
  apiKey: 'AIzaSyAlpArQPeJtpPIAoQxXOsZbYI3wBDXQsVs',
  authDomain: 'dev-cw-red.firebaseapp.com',
  databaseURL: 'https://dev-cw-red.firebaseio.com',
  projectId: 'dev-cw-red',
  storageBucket: 'dev-cw-red.appspot.com',
  messagingSenderId: '961700130503',
  appId: '1:961700130503:web:d3121970d98aec8d5fd8e2',
  measurementId: 'G-ECYGTN66TN',
};
